const Immutable = require('immutable')
const React = require('react')

module.exports = withImmutableProps

// A Higher-Order-Component to convert Immutable props into plain JS Objects
// https://redux.js.org/recipes/using-immutable.js-with-redux

function withImmutableProps(WrappedComponent) {
  class WithImmutableProps extends React.PureComponent {
    render() {
      return React.createElement(WrappedComponent, propsToJS(this.props))
    }
  }
  WithImmutableProps.displayName = `WithImmutableProps(${getDisplayName(WrappedComponent)})`
  return WithImmutableProps
}

function propsToJS(props) {
  return Object.keys(props)
  .reduce((newProps, key) => {
    const value = props[key]
    newProps[key] = Immutable.isImmutable(value) ? value.toJS() : value
    return newProps
  }, {})
}

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component'
}
